IntlMessageFormat.__addLocaleData({"locale":"nb","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"nb-NO","parentLocale":"nb"});
IntlMessageFormat.__addLocaleData({"locale":"nb-SJ","parentLocale":"nb"});
